<template>
    <VJoyButton
        icon="pen"
        size="xsmall"
        :label="$t('profile.vetting.drawer.edit')"
        data-testid="vetting-edition-edit-button"
        variant="main"
        :aria-label="$t('general.edit')"
        @click="profileQualificationStore.enterEditMode()"
    />
</template>

<script setup lang="ts">
    import {VJoyButton} from '@maltjoy/core-vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';

    const profileQualificationStore = useProfileQualificationStore();
</script>
